import { Injectable } from '@angular/core';
import { ConfirmWaits } from './confirm-lane';

@Injectable({ providedIn: 'root' })
export class ConfirmWaitsNgService extends ConfirmWaits {
  constructor() {
    super();
  }
}
